import React from "react"
import Section from "../../../../core/layout/main/section/Section"
import Card from "../../../common/blocks/card/Card"
import Button from "../../../common/blocks/button/Button"

function CategoryCard({ item }) {
  return (
    <Card
      key={item.id}
      className="col p-3 secondary-background-color no-shadow min-w-20 max-w-50 w-100"
    >
      <h3>{item.attributes.label}</h3>
      <p className="mbl-2 line-clamp-3">{item.attributes.descriptionCardCarrefour}</p>
      <Button
        aspect="classique"
        color="primary"
        size="large"
        ctalink={item.attributes.autoRoute}
      >
        Découvrir
      </Button>
    </Card>
  )
}

function CtxProductCategorySection({ productCategory }) {
  const hasProducts = productCategory.products?.length > 0
  const hasChildren = productCategory.children?.length > 0

  return (
    <Section container="large pbl-12">
      {hasProducts && (
        <>
          {productCategory.attributes.titleProductsSectionCarrefour && (
            <h2 className="text-center mb-6 loadin">
              {productCategory.attributes.titleProductsSectionCarrefour}
            </h2>
          )}
          <div className="row justify-content-center gap-3 loadin">
            {productCategory.products.map((product) => (
              <CategoryCard
                key={product.id}
                item={product}
              />
            ))}
          </div>
        </>
      )}
      {hasChildren && (
        <>{productCategory.attributes.titleSectionCarrefour && (
            <h2 className="text-center mt-12 mb-6 loadin">
              {productCategory.attributes.titleSectionCarrefour}
            </h2>
          )}
          <div className="row justify-content-center gap-3 loadin">
            {productCategory.children.map((child) => (
              <CategoryCard
                key={child.id}
                item={child}
              />
            ))}
          </div>
        </>
      )}
    </Section>
  )
}
export const name = "CtxProductCategory"

export const init = (componentData, pageContext) => {
  return <CtxProductCategorySection 
    key={componentData.id}
    productCategory={pageContext.itemData} 
    />
}

export default CtxProductCategorySection
